<template>
  <v-card
    :disabled="loading"
    :loading="loading"
    class="AssignmentStartTestCard"
  >
    <v-card-title class="d-flex justify-center">
      {{ assignmentRunning ? 'Assignment is running' : 'Run assignment' }}
    </v-card-title>
    <v-card-text>
      <v-alert
        type="warning"
        text
        border="left"
      >
        Please make sure you have stable internet connection
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="!canRunTest"
        :loading="loading"
        large
        color="primary"
        class="white--text"
        @click="$emit('start')"
      >
        {{ assignmentRunning ? 'Continue' : 'Start test' }}
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'AssignmentStartTestCard',
  props: {
    assignment: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    attemptsLeft: {
      type: Number,
      default: 0,
    },
    canRunTest: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    assignmentRunning() {
      const reports = this.assignment.reports || [];
      const lastReport = reports[reports.length - 1];
      return lastReport && !lastReport?.finished;
    },
  },
};
</script>
